// Sede por defecto del modulo de tickets. El modulo aun no tiene contexto de
// sede propio, asi que de momento se fija a CEDESCA (decision de producto).
export const TICKETS_HEADQUARTER = 'CEDESCA';

// Tamano de pagina por defecto para la cola de tickets.
export const PAGE_SIZE = 25;

// Limite por fichero adjunto (~3,7 MB; el backend sube a Google Drive en base64).
export const MAX_ADJUNTO_BYTES = 3_700_000;

// Estados semilla del backend (ids fijos 1..6). tone alinea con las clases de
// badge del SCSS (.tickets-badge--azul/--aviso/--exito/--gris).
export const ESTADOS_META = {
  1: { label: 'Nuevo', tone: 'azul' },
  2: { label: 'Abierto', tone: 'azul' },
  3: { label: 'Pendiente', tone: 'aviso' },
  4: { label: 'En espera', tone: 'aviso' },
  5: { label: 'Resuelto', tone: 'exito' },
  6: { label: 'Cerrado', tone: 'gris' },
};

// Enum de prioridad (coincide con el backend).
export const PRIORIDADES = {
  baja: { label: 'Baja', color: '#cbd5e1' },
  normal: { label: 'Normal', color: '#94a3b8' },
  alta: { label: 'Alta', color: '#ee9d01' },
  urgente: { label: 'Urgente', color: '#f64e60' },
};

export const PRIORIDAD_KEYS = Object.keys(PRIORIDADES);

// Estados en los que el SLA ya no corre (Resuelto / Cerrado): no se pinta badge.
export const ESTADOS_SIN_SLA = [5, 6];

// Umbral de aviso de SLA. Un ticket esta "por vencer" cuando le queda <=25% de
// su ventana de SLA (vence_sla_en - creado_en). Si el backend no envia creado_en
// se usa el fallback fijo (4 h) como margen de aviso.
export const SLA_AVISO_RATIO = 0.25;
export const SLA_AVISO_MS = 4 * 60 * 60 * 1000;

// Enum de canal de entrada del ticket.
export const CANALES = ['email', 'portal', 'telefono', 'chat', 'manual'];

// Vistas del Rail: presets de filtros sobre el endpoint de lista. La vista
// 'mias' inyecta en runtime el agente del usuario logueado.
// Nota: estado es un filtro unico en el backend, por eso 'cerradas' usa
// solo Cerrado (6) y 'esperando' solo En espera (4).
export const VISTAS = [
  { id: 'mias', label: 'Mis tickets abiertos', filtros: {} },
  { id: 'sinasignar', label: 'Sin asignar', filtros: { sin_asignar: true } },
  { id: 'esperando', label: 'Esperando cliente', filtros: { estado: 4 } },
  { id: 'cerradas', label: 'Cerradas', filtros: { estado: 6 } },
  { id: 'todos', label: 'Todos', filtros: {} },
];

// Emails autorizados a gestionar (crear/editar/borrar) las respuestas guardadas.
// El enforcement real es server-side (403 al resto); esta lista solo gobierna la
// visibilidad del formulario en el front.
export const RESPUESTAS_ADMIN_EMAILS = [
  'selmorabit@cedetecgroup.com',
  'selmorobit@cedetecgroup.com', // grafia alternativa vista en /accesos; el backend valida la lista real
  'jredondo@cedetecgroup.com',
];

// Buzon de soporte (el que recibe los correos y envia las respuestas). Nunca es
// candidato a CC: el backend lo rechaza porque la copia volveria a entrar como
// correo nuevo.
export const BUZON_SOPORTE = 'soporte@cedetecgroup.com';

// Tope de correos en copia por ticket (igual que el backend).
export const MAX_CC_TICKET = 20;
